<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="area_wrap">
          <div class="result_wrap" v-if="getCheckup.categoryCode === 1">
            <div class="rw_titleWrap">
              <div class="rw_title">
                <div class="imgWrap" @click.prevent="direction(false)">
                  <img src="@/assets/images/back.svg">
                </div>
                <p class="blue">병리검사결과</p>
                <div class="imgWrap reverse" @click.prevent="direction(true)">
                  <img src="@/assets/images/back.svg">
                </div>
              </div>
              <span>검사일: {{getCheckupDetail.pathologyCheckup.checkupDate | moment('YYYY-MM-DD')}}</span>
            </div>
            <div class="board_wrap">
              <div class="board_body">
                <div class="write_space detail">
                  <p v-html="getCheckupDetail.pathologyCheckup.resultValue">내용</p>
                </div>
              </div>
            </div>
            <div class="description center">
              <div class="pb-10">
<!--                <p>*검사 결과와 관련된 일반적인 설명(FAQ)은 <b><router-link to="/">여기</router-link></b>를 참고하세요.</p>-->
                <p>*더 자세한 설명이나 상담을 원하시는 분은 병원에 내원하셔서</p>
                <p>진료를 보셔야 합니다.</p>
              </div>
              <div class="small_btnWrap one">
                <router-link to="../../reservation/explain">
                  <button type="button">예약하기</button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btnWrap visible">
        <router-link to="/checkup/checkupList">
          <button type="button" class="callTerms">목록</button>
        </router-link>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '검사결과 조회',
        prevUrl: '/checkup/checkupList'
      },
      checkupList: [],
      imgOn: 'dropdown1.svg',
      imgUn: 'dropdown2.svg',
      status: {
        normal: false,
        low: false,
        high: false
      },
      history: false,
      show: false,
      opened: [],
      detailSet: [],
      trackIndex: '',
      nextCheckupCode: '',
      trans: false
    }
  },
  computed: {
    ...mapGetters('checkup', [
      'getCheckupDetail',
      'getCheckup',
      'getCheckupList'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP',
      'SET_CHECKUP'
    ]),
    ...mapActions('checkup', [
      'CHECKUP_DETAIL'
    ]),
    toggleEvent (b) {
      console.log('b: ', b)
      const index = this.opened.indexOf(b)
      if (index > -1) {
        console.log(index)
        this.opened.splice(index, 1)
        console.log(this.opened)
      } else {
        this.opened.push(b)
      }
      // const areaArr = document.querySelectorAll('.present')
      //
      // areaArr.forEach((area) => {
      //   const content = area.querySelector('.old')
      //   const btn = area.querySelector('.moreBtn')
      //   const arrow = btn.querySelector('img')
      //
      //   btn.addEventListener('click', () => {
      //     /* 한개 열리면 다른건 접히도록 */
      //     // if (content.classList.contains('show')) {
      //     //   areaArr.forEach((el) => {
      //     //     el.childNodes[1].classList.remove('show')
      //     //   })
      //     // }
      //     arrow.classList.toggle('rotate')
      //     for (let i = 0; i < content.length; i++) {
      //       content[i].classList.toggle('show')
      //     }
      //   })
      // })
    },
    dataTransForm () {
      const result = document.querySelectorAll('.result')
      const resultList = [].slice.call(result)
      const resultValue = resultList.map(function (e) {
        return e.innerText
      })

      const judge = document.querySelectorAll('.judge')
      const judgeList = [].slice.call(judge)
      const judgeValue = judgeList.map(function (e) {
        return e.innerText
      })
      // console.log('resultValue: ', resultValue)
      // console.log('judgeValue: ', judgeValue)
      // console.log('judge: ', judge)

      for (let i = 0; i < resultValue.length; i++) {
        if (resultValue[i] > 10) {
        }
      }

      for (let i = 0; i < judgeValue.length; i++) {
        if (judgeValue[i] === '-') {
          this.status.normal = true
          judge[i].classList.add('normal')
          judge[i].parentNode.classList.add('normalTd')
          judge[i].parentNode.parentNode.classList.add('normalTr')
          judge[i].parentNode.nextSibling.childNodes[0].innerText = '정상'
        } else if (judgeValue[i] === 'L') {
          this.status.normal = false
          this.status.low = true
          judge[i].classList.add('low')
          judge[i].parentNode.classList.add('lowTd')
          judge[i].parentNode.parentNode.classList.add('lowTr')
          judge[i].parentNode.nextSibling.childNodes[0].innerText = '비정상'
        } else if (judgeValue[i] === 'H') {
          this.status.normal = false
          this.status.low = false
          this.status.high = true
          judge[i].classList.add('high')
          judge[i].parentNode.classList.add('highTd')
          judge[i].parentNode.parentNode.classList.add('highTr')
          judge[i].parentNode.nextSibling.childNodes[0].innerText = '비정상'
        }
      }
    },
    firstSet () {
      console.log('처음')
      const excu = Object.entries(this.getCheckupList)
      const keyArray = []
      const valueArray = []
      let location = ''
      for (const [key, value] of excu) {
        keyArray.push(key)
        valueArray.push(value)
      }
      for (let i = 0; i < this.getCheckupList.length; i++) {
        if (valueArray[i].id === this.getCheckup.checkupCode) {
          location = i
        }
      }
      this.trackIndex = location
    },
    setData () {
      console.log('2번쨰')
      const excu = Object.entries(this.getCheckupList)
      const keyArray = []
      const valueArray = []
      let location = ''
      for (const [key, value] of excu) {
        keyArray.push(key)
        valueArray.push(value)
      }
      console.log('keyArray: ', keyArray)
      console.log('valueArray: ', valueArray)
      for (let i = 0; i < this.getCheckupList.length; i++) {
        if (valueArray[i].id === this.nextCheckupCode) {
          location = i
        }
      }
      this.trackIndex = location
    },
    async direction (direction) {
      if (this.trans) {
        this.setData()
      }
      const currentCount = this.trackIndex
      console.log('현재코드', currentCount)
      if (direction) {
        try {
          const requestData = {
            categoryCode: this.getCheckupList[currentCount + 1].categoryCode,
            checkupCode: this.getCheckupList[currentCount + 1].id,
            checkupDate: this.getCheckupList[currentCount + 1].checkupDate
          }
          console.log('null 값 찾기', this.getCheckupList[currentCount + 1])
          console.log('리퀘스트 데이터', requestData)
          await this.CHECKUP_DETAIL(requestData)
            .then(() => {
              this.nextCheckupCode = this.getCheckupList[currentCount + 1].id
              this.trackIndex++
              console.log('루프를 타고나온 코드', this.trackIndex)
              console.log('다음코드', this.nextCheckupCode)
              this.trans = true
            })
          if (this.getCheckupList[currentCount + 1].categoryCode === 0) {
            await this.$router.push(`/checkup/blood/bloodCheckup/${this.getCheckupList[currentCount + 1].id}`)
          } else if (this.getCheckupList[currentCount + 1].categoryCode === 1) {
            await this.$router.push(`/checkup/pathology/pathologyCheckup/${this.getCheckupList[currentCount + 1].id}`)
          }
        } catch (error) {
          console.log('error :', error);
          console.log('병리검사결과조회 상세보기 api에서 에러발생 (화살표로 이동했을 때)')
          if (error.status !== 401) {
            this.SET_POPUP(true)
            this.popupSet.content = errorParser.parse(error)
          } else {
            await this.$router.push('/login')
          }
        } finally {

        }
      } else {
        try {
          const requestData = {
            categoryCode: this.getCheckupList[currentCount - 1].categoryCode,
            checkupCode: this.getCheckupList[currentCount - 1].id,
            checkupDate: this.getCheckupList[currentCount - 1].checkupDate
          }
          await this.CHECKUP_DETAIL(requestData)
            .then(() => {
              this.nextCheckupCode = this.getCheckupList[currentCount - 1].id
              this.trackIndex--
              console.log('루프를 타고나온 코드', this.trackIndex)
              console.log('다음코드', this.nextCheckupCode)
              this.trans = true
            })

          if (this.getCheckupList[currentCount - 1].categoryCode === 0) {
            await this.$router.push(`/checkup/blood/bloodCheckup/${this.getCheckupList[currentCount - 1].id}`)
          } else if (this.getCheckupList[currentCount - 1].categoryCode === 1) {
            await this.$router.push(`/checkup/pathology/pathologyCheckup/${this.getCheckupList[currentCount - 1].id}`)
          }
        } catch (error) {
          console.log('error :', error);
          console.log('병리검사결과조회 상세보기 api에서 에러발생 (화살표로 이동했을 때)')
          if (error.status !== 401) {
            this.SET_POPUP(true)
            this.popupSet.content = errorParser.parse(error)
          } else {
            await this.$router.push('/login')
          }
        } finally {

        }
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.dataTransForm()
    })
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  created () {
    this.firstSet()
    console.log('있는 것의 끝', this.getCheckupList)
    console.log('this.getCheckup.checkupCode', this.getCheckup.checkupCode)
  }
}
</script>

<style lang="scss" scoped>
</style>
